import { render } from "./NavigationFooterMenu.vue?vue&type=template&id=35c1e459&scoped=true"
import script from "./NavigationFooterMenu.vue?vue&type=script&lang=js"
export * from "./NavigationFooterMenu.vue?vue&type=script&lang=js"

import "./NavigationFooterMenu.vue?vue&type=style&index=0&id=35c1e459&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c1e459"]])

export default __exports__